__turbopack_context__.v({
  "contentWrapper": "ToastProvider-module-scss-module__zcshaa__contentWrapper",
  "description": "ToastProvider-module-scss-module__zcshaa__description",
  "descriptionButton": "ToastProvider-module-scss-module__zcshaa__descriptionButton",
  "descriptionLink": "ToastProvider-module-scss-module__zcshaa__descriptionLink",
  "errorIcon": "ToastProvider-module-scss-module__zcshaa__errorIcon",
  "iconWrapper": "ToastProvider-module-scss-module__zcshaa__iconWrapper",
  "successIcon": "ToastProvider-module-scss-module__zcshaa__successIcon",
  "title": "ToastProvider-module-scss-module__zcshaa__title",
  "txLinkIcon": "ToastProvider-module-scss-module__zcshaa__txLinkIcon",
  "warnIcon": "ToastProvider-module-scss-module__zcshaa__warnIcon",
  "wrapper": "ToastProvider-module-scss-module__zcshaa__wrapper",
});
